import React from 'react';
import styled from '@emotion/styled';
import { Button, Typography } from 'antd';
import { appStyles } from '../../../../styles';
import { Align } from '../../../../types/common';

export interface AttributeValues {
  backgroundImage?: string;
  textColor?: string;
  description?: string;
  title?: string;
  ctaText?: string;
  colorOpacity?: string;
  heading?: string;
  priceColor?: string;
  buttonBGColor?: string;
  buttonTextColor?: string;
}
interface PreviewProps {
  values: AttributeValues & any;
  isDisplayText?: boolean;
  isToUpperCase?: boolean;
  isPreview?: boolean;
  height?: string;
  className?: string;
  isPromotionPreview?: boolean;
}

const toButtonAlign = (buttonAlign: Align) => {
  if (buttonAlign === Align.LEFT) {
    return 'flex-start';
  }
  if (buttonAlign === Align.RIGHT) {
    return 'flex-end';
  }
  if (buttonAlign === Align.CENTER) {
    return 'center';
  }
  return 'flex-start';
};

const { Text } = Typography;

export const Preview = (props: PreviewProps) => {
  const { values, isDisplayText, isToUpperCase, isPreview, height, className, isPromotionPreview } = props;
  const {
    backgroundImage,
    textColor,
    description,
    title,
    ctaText,
    colorOpacity,
    heading,
    textAlign,
    priceColor,
    buttonTextColor,
    buttonBGColor,
    describeText,
    buttonAlign,
  } = values;

  const color = textColor || '#fff';
  const btnTextColor = buttonTextColor || '#000';
  const btnBGColor = buttonBGColor || '#fff';
  const isDefaultImage = backgroundImage === '' || !backgroundImage || !isPreview;
  return (
    <StyledPromotionPreview
      className={`Preview ${isDefaultImage ? 'default-image' : ''} ${className}`}
      style={{ height: height || '300px' }}
    >
      <div className="preview-ant-image">
        <StyledLinearGradient
          style={{
            background: `linear-gradient(180deg, transparent, rgba(0, 0, 0, ${
              isNaN(Number(colorOpacity)) ? 0 : Number(colorOpacity)
            })), 50%`,
          }}
        />
        {!isDefaultImage ? <img src={backgroundImage} alt="" /> : null}
        {describeText && isDefaultImage ? <div className="uploadText">{describeText}</div> : null}
        {isDisplayText && (
          <div className="textContainer">
            {heading && <Text className="heading">{heading}</Text>}
            <div
              className={`wrapper-text-preview ${isPromotionPreview ? 'promotion-preview' : ''}`}
              style={{ textAlign }}
            >
              <>
                {priceColor && (
                  <Text className="priceColor" style={{ color: priceColor }}>
                    $XXX.XX
                  </Text>
                )}
                <Text className="title" style={{ color }}>
                  {title && isToUpperCase ? title.toUpperCase() : title}
                </Text>
                <br />
                <Text className="description" style={{ color }}>
                  {description && isToUpperCase ? description.toUpperCase() : description}
                </Text>
              </>
            </div>
            {ctaText && (
              <div className="wrapper-btn-preview" style={{ justifyContent: toButtonAlign(buttonAlign || textAlign) }}>
                <Button
                  className="button"
                  style={{ background: btnBGColor, color: btnTextColor, borderColor: btnBGColor }}
                >
                  {ctaText}
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    </StyledPromotionPreview>
  );
};

const StyledLinearGradient = styled.div`
  ${appStyles.fullWidthHeight}
  ${appStyles.borderRadiusPreview}
  position: absolute;
`;

const StyledPromotionPreview = styled.div`
  ${appStyles.borderRadiusPreview}
  margin: 2rem;
  min-height: 293px;
  position: relative;
  text-align: left;
  font-family: 'DIN Condensed Bold';
  line-height: 1.2;
  & .heading {
    position: absolute;
    top: -24px;
    left: 0;
    width: 300px;
    font-size: 18px;
  }
  & .preview-ant-image {
    width: 100%;
    margin: 0;
    position: absolute;
    img {
      width: 100%;
      ${appStyles.borderRadiusPreview}
      padding: 0;
      border: 1px solid transparent;
    }
  }
  .uploadText {
    position: absolute;
    width: 100%;
    text-align: center;
    margin-top: 4rem;
    color: white;
  }
  .textContainer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .wrapper-text-preview {
    position: absolute;
    bottom: 20%;
    width: 100%;
    padding: 0 1rem;
  }
  & .title {
    font-size: 25px;
  }
  & .priceColor {
    display: block;
    font-size: 11px;
  }
  .promotion-preview {
    & .description {
      font-size: 25px;
    }
    & .title {
      font-size: 14px;
    }
  }
  & .wrapper-btn-preview {
    position: absolute;
    bottom: 8px;
    width: 100%;
    display: flex;
    padding: 0 1rem;
    & .button {
      border-radius: 1rem;
      background: #fff;
      color: #000;
      height: 30px;
      font-size: 16px;
      padding: 0.2rem 1.25rem 0 1.25rem;
    }
  }

  @media screen and (max-width: 1440px) {
    .text-preview {
      bottom: 13%;
    }
    & .description {
      font-size: 12px;
    }
    & .title {
      font-size: 21px;
    }

    .promotion-preview {
      & .description {
        font-size: 21px;
      }
      & .title {
        font-size: 15px;
      }
    }
  }
`;
